import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/重生之翼";
import { Soulmark } from "../../core/soulmark";
import { 神耀能量 } from "../../core/buff";
import { Effect } from "../../core/effect";
import * as effect from "../../core/effect";
import { Timing } from "../../core/timing";

export class 重生之翼 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(2987, "重生之翼", type.王, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.addBuff(new 神耀能量());
        this.魂印 = new Soulmark(
            [
                "重生之翼可以通过使用技能获得<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，最多可以储存6层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>。每储存1层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，可以获得相应的效果：",
                "1层：每储存1层<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，受到的攻击伤害减少10%；",
                "2层：免疫异常状态，不受能力下降效果影响；",
                "3层：回合结束时恢复最大体力的1/3；",
                "4层：免疫固定伤害，且回合结束时将之以固定伤害的形式等量反馈给对手；",
                "5层：所有技能先制额外+1；",
                "6层：所有技能威力提升60%。",
                "击败对手后，消耗当前全部<span style='color: #33c0ed; font-weight: bold;'>神耀能量</span>，每消耗1层使自身下1回合先制+1且吸取对手最大体力的8%。",
                "当重生之翼被击败时，随机复活背包内一只已战败的其他精灵。",
            ],
            [
                new Effect(
                    new effect.减伤(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) * 10),
                    Timing.beforeDamage,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 1),
                new Effect(
                    new effect.免疫异常状态(),
                    Timing.beforeSkillHit,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 2),
                new Effect(
                    new effect.免疫能力下降(),
                    Timing.beforeSkillHit,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 2),
                new Effect(
                    new effect.恢复体力(({ sbjPet }) => Math.round(sbjPet.最大体力 / 3)),
                    Timing.battleStageEnd,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 3),
                new Effect(
                    new effect.免疫固定伤害(),
                    Timing.beforeSkillHit,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 4),
                new Effect(
                    new effect.神耀能量固定伤害反馈(),
                    Timing.battleStageEnd,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 4),
                new Effect(
                    new effect.先制(1),
                    Timing.battleStageBegin,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 5),
                new Effect(
                    new effect.威力提升(60),
                    Timing.beforeDamage,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) >= 6),
                new Effect(
                    new effect.消耗神耀能量并获得击败奖励(),
                    Timing.onDefeat,
                ).withPresence(({ sbjPet }) => (sbjPet.getBuff(神耀能量)?.stacks ?? 0) > 0),
                new Effect(
                    new effect.随机复活一只已战败的其他精灵(),
                    Timing.petDead,
                ),
            ],
        );
        this.技能组 = [
            skill.银雾之翼,
            skill.挚金命轮,
            skill.黎羽幻生,
            skill.无上天命剑,
            skill.正义天启歌,
        ];
    }
}
